import Modal from '@mui/material/Modal';
import dynamic from 'next/dynamic';

const MdClear = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdClear)
);

const CustomModal = ({
  title,
  width = 'w-full md:w-[670px]',
  padding = 'p-6',
  customModalHeader,
  modalOpen = false,
  setModalOpen = () => {},
  children,
  showClose = true,
  subtitle,
  showFooter = false,
  footerContent = {},
  icon,
}) => {
  return (
    <Modal
      className=' flex max-h-[calc(100vh-50px)] items-center justify-center'
      open={!!modalOpen}
      onClose={() => {
        setModalOpen(false);
      }}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
    >
      <div
        className={`mx-[8px] max-h-[calc(100vh-63px)] rounded-[2px] border border-[#EBEBEB] bg-white ${padding} ${width} max-w-[100vw]`}
      >
        {customModalHeader ? (
          customModalHeader
        ) : (
          <div className='flex items-center justify-between gap-4'>
            <div className='flex items-center gap-2'>
              {icon}
              <div>
                <h3 className='line-clamp-1 max-w-[500px] text-[22px]  font-semibold text-[#2C2C2C]'>
                  {title}
                </h3>
                {subtitle && <p className='text-[14px] text-mid'>{subtitle}</p>}
              </div>
            </div>
            {showClose && (
              <MdClear
                className='cursor-pointer text-[22px] text-[#2C2C2C]'
                onClick={() => {
                  setModalOpen(false);
                }}
              />
            )}
          </div>
        )}
        <div
          className={` custom-scrollbar mt-4 max-h-[calc(100vh-150px)] overflow-y-auto overflow-x-hidden`}
        >
          {children}
          {showFooter && (
            <div className='flex items-center justify-end gap-[16px] px-[8px] py-[8px]'>
              <div
                onClick={footerContent.cancelHandler}
                className='cursor-pointer rounded-[100px] px-[32px] py-[6px] text-body-1-bold text-high'
              >
                {footerContent.cancelText}
              </div>
              <div
                onClick={footerContent.okHandler}
                className='cursor-pointer rounded-[100px] bg-primary px-[32px] py-[7px] text-body-1-bold text-white'
              >
                {footerContent.okText}
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default CustomModal;
